import React from "react";

interface CheckIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
  color?: string;
}

const CheckIcon: React.FC<CheckIconProps> = ({ width = 32, height = 32, className, color = "currentColor" }) => (
  <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M29.0681 13.3333C29.6771 16.3217 29.2431 19.4285 27.8386 22.1357C26.4341 24.8429 24.144 26.9867 21.3502 28.2097C18.5563 29.4328 15.4276 29.661 12.4859 28.8565C9.5441 28.0519 6.96705 26.2632 5.1845 23.7885C3.40195 21.3139 2.52163 18.303 2.69035 15.2578C2.85907 12.2127 4.06664 9.31744 6.11167 7.05488C8.1567 4.79232 10.9156 3.29923 13.9282 2.82459C16.9409 2.34995 20.0252 2.92247 22.6668 4.44665"
      stroke={color}
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12 14.6668L16 18.6668L29.3333 5.3335" stroke={color} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default CheckIcon;
